import * as actionTypes from '../constants/actionTypes';

export default(state = {}, action) => {
    switch (action.type) {
        case actionTypes.API_ACCESS_TOKEN_LIST:
            return {
                ...state,
                list: action.payload
            };
        case actionTypes.API_ACCESS_TOKEN_CLEAR:
            return {
                ...state,
                list: null
            };
        default:
            return state;
    }
};